import React from "react";
import { connectMonitorOptions } from "./MonitoringConnect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckSquare,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import HelpButton from "../HelpContent/HelpButton";

export const isConfigurationComplete = (
  service,
  monitor,
  monitorBroadcasts
) => {
  let isValid = false;
  const communicationBroadcast = monitorBroadcasts?.communication?.broadcast;
  const communicationSendList = monitorBroadcasts?.communication?.sendList;
  const assetBroadcast = monitorBroadcasts?.asset?.broadcast;

  if (service === "IsComponent") {
    isValid = true;
  } else if (
    service === "IsCommunication" &&
    !!communicationBroadcast?.Messages?.some((m) =>
      m.Message.EditorState.blocks?.some((b) => !!b.text)
    ) ===
      (!!communicationSendList?.contacts?.length ||
        !!communicationSendList?.contactSets?.length)
  ) {
    isValid = true;
  } else if (
    service === "IsAsset" &&
    !!assetBroadcast?.Messages?.some((m) =>
      m.Message.EditorState.blocks?.some((b) => !!b.text)
    ) === !!monitor?.WithAssets?.length
  ) {
    isValid = true;
  }
  return isValid;
};

export default function ConnectMonitor({
  monitor,
  monitorBroadcasts = {},
  connectMonitor,
  setConnectMonitor,
}) {
  return (
    <div>
      <div className="mb-3">
        <span className="fs-4 fw-bold">
          What Logic service do you want to connect the Monitor to?
          <HelpButton helpKey="monitoring-connect" />
        </span>
      </div>
      <div>
        {/* <div className="">
            {connectMonitorOptions
              .filter((o) => monitor[o.name])
              .map((o) => o.heading)
              .join(", ") || "Please select..."}
          </div> */}

        <div className="bg-white text-black w-100 border-0 justify-content-between align-items-center">
          {connectMonitorOptions.map((o) => (
            <div
              key={o.name}
              className={`border-bottom ${o.isDisabled ? "opacity-50" : ""} ${
                o.name === connectMonitor ? "bg-primary bg-opacity-25" : ""
              }`}
              disabled={o.isDisabled}
            >
              <button
                type="button"
                className={`btn text-start w-100`}
                onClick={(e) => {
                  e.preventDefault();
                  setConnectMonitor(o.name);
                }}
              >
                <div className="row ms-1">
                  <div className="col-3 d-flex align-items-center justify-content-center ">
                    {o.heading}{" "}
                  </div>
                  <div className="p-3 text-secondary col-7">{o.info}</div>
                  <div className="col-2 d-flex align-items-center justify-content-center">
                    {monitor[o.name] && (
                      <FontAwesomeIcon
                        icon={faCheckSquare}
                        size="lg"
                        className="text-purple ms-n2"
                      />
                    )}
                    {!isConfigurationComplete(
                      o.name,
                      monitor,
                      monitorBroadcasts
                    ) && (
                      <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        size="lg"
                        className="text-danger ms-n2"
                        title="Configuration is not complete"
                      />
                    )}
                  </div>
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
